module Meevo.Components.Controls {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import SecurityParts = Meevo.Components.Common.SecurityParts;

    interface IPagerItem extends Object {
        overridableFields?: string;
    }

    export class MeevoPager {

        restrict = 'E';
        require = '^form';
        controller = 'meevo.components.controls.MeevoPagerController';
        scope = {
            baseEndpoint: "@",
            context: "=",
            sectionEndpoint: "@",
            parentItemId: "@",
            allowCrud: "=",
            requestData: "=?",
            extendRequest: "=?",
            asLocationId: "=",
            addTemplateUrl: "@",
            itemTemplateUrl: "@",
            filterTemplateUrl: "@",
            initializeAddItem: "&?",
            itemSelectedAction: "&?",
            securityKey: "@?",
            sortDirection: "@?",
            postSavePreMerge: "&",
            defaultCriteria: "&?",
            crudTemplate: "@?",
            itemsArray: "=?",
            isSelected: "&?",
            onPageLoaded: "&?",
            pageSize: "@?",
            onApplyFilter: "&?",
            templateController: "@?",
            coMobileSearchFilterTemplate: "@?",
            chipTemplate: "@?",
            coSearchTemplate: "@?",
            noResultsMessage: "@?",
            hideContextCrud: "=",
            customSubmitForm: "&?",
            asyncPreSelectPage: "&?",
            templateUrl: "@?",
            isSaveEqual: "=?",
            isAudited: "=?",
            showPaging: "=?",
            hasHotKeys: "=?",
            disableInitialRequest: '=?',
            sortBy: "@?",
        };

        templateUrl = (elem, attrs) => {
            return attrs.templateUrl || 'app/components/controls/pagerTemplate.html';
        }

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formCtrl: any) => {
            ////when destroying pager scope, reset default display values to maint crud
            //  scope.$on('$destroy', function () {
            //      //maintFormCrudTrayNoMobile.css("position", "relative");
            //      //maintFormCrudTrayMobile.css("position", "relative");
            //      if ((maintFormCrudTrayNoMobile || maintFormCrudTrayMobile) && scope.hideContextCrud) {
            //          maintFormCrudTrayNoMobile.css("bottom", "0");
            //          maintFormCrudTrayMobile.css("bottom", "0");
            //          pagerCrud.remove();
            //      }

            //      //pagerCrud.append.(maintFormCrudTrayNoMobile)
            //      //pagerCrud.append(maintFormCrudTrayMobile);
            //});
            //var maintFormCrudTrayNoMobile = angular.element('#maint-crud-no-mobile');
            //var maintFormCrudTrayMobile = angular.element('#maint-crud-mobile');
            //var pagerCrud = angular.element('.pager-crud-default');
            //var pagerCrudAnchor = angular.element('#pager-crud-work-around');
            //// to hide maint for default crud, check hideContextCrud bool.
            //if ((maintFormCrudTrayNoMobile || maintFormCrudTrayMobile) && scope.hideContextCrud) {
            //    //maintFormCrudTrayNoMobile.css("position", "absolute");
            //    //maintFormCrudTrayMobile.css("position", "absolute");
            //    maintFormCrudTrayNoMobile.css("bottom", "1010000px");
            //    maintFormCrudTrayMobile.css("bottom", "1010000px");
            //    pagerCrudAnchor.append(pagerCrud);
            //    pagerCrudAnchor.append(pagerCrud);
            //}
            scope.hidePagerBar = false;

            scope.item = {};
            if (_.isUndefined(scope.isSaveEqual)) {
                scope.isSaveEqual = true;
            }

            if (_.isUndefined(scope.showPaging)) {
                scope.showPaging = true;
            }

            if (!scope.noResultsMessage) {
                scope.noResultsMessage = "LABEL_NO_RESULTS";
            }

            if (_.isFunction(scope.defaultCriteria)) {
                scope.criteria = scope.defaultCriteria();
            } else {
                scope.criteria = {};
            }

            scope.hotKeyClass = () => {
                if (scope.hasHotKeys) {
                    return "sm light";
                } else {
                    return "hide";
                }
            }

            scope.hotKeyClass = () => {
                if (scope.hasHotKeys) {
                    return "sm light";
                } else {
                    return "hide";
                }
            }

            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;

            // TODO: Review with Dave - originally thinking of leveraging the canXXXX() functions for add, edit, delete
            // for security, but there are some considerations when it comes to elevatable and the fact that the "buttons"
            // aren't actually buttons. For now using the regular directive on the add/edit/delete buttons in the template
            // and then binding to the keys built here.
            if (!_.isEmpty(scope.securityKey)) {
                scope.addSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
                scope.editSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
                scope.deleteSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            }

            /**
            * Executes the externally defined itemSelectedAction (if supplied).
            * This allows for peforming actions such as viewing details on the selected
            * item without having the sublist need to know about the implementation.
            */
            scope.selectItem = (itemId: any): void => {
                if (_.isFunction(scope.itemSelectedAction)) {
                    scope.itemSelectedAction(itemId);
                }
            }


            /**
            * Initiates adding a new item.
            */
            scope.addNew = (): void => {
                if (_.isFunction(scope.initializeAddItem)) {
                    scope.initializeAddItem().then(result => {
                        scope.viewMode = Meevo.Model.MaintenanceFormState.Adding;
                        scope.item = result;
                        scope.openModal(scope.item);
                    });
                } else {
                    scope.viewMode = Meevo.Model.MaintenanceFormState.Adding;
                    scope.openModal(null);
                }
            }

            /* END: Add New Functionality */

            /* START: Edit Functionality */

            /**
            * Initiates an editing session for the supplied item.
            */
            scope.editItem = (item: any): void => {
                scope.viewMode = Meevo.Model.MaintenanceFormState.Editing;
                scope.openModal(item);
            }

            /* END: Edit Functionality */

            /* START: Delete Functionality */

            /**
            * Handles confirmation and deletion of an item.
            */
            scope.deleteItem = (item: any): void => {
                this.modalService.confirm("MESSAGE_DELETE_CONFIRMATION").then((confirmResult: boolean) => {
                    if (confirmResult) {
                        this.loggingService.trace(`Deleting item ${item.id}`);
                        this.dataService.delete(scope.baseEndpoint, scope.parentItemId, item.entityVersion, null, scope.sectionEndpoint, item.id).then(() => {
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                            item.isEditing = false;
                            this.loggingService.trace(`${item.id} Successfully Deleted`);

                            scope.items.initSearch(buildRequest());
                        });
                    }
                });
            }

            /* END: Delete Functionality */

            /* START: Common Functionality */

            /**
            * Handles Persisting an item during an Add/Edit session.
            */
            scope.save = (): void => {
                if (scope.viewMode === Meevo.Model.MaintenanceFormState.Adding) {
                    this.loggingService.trace(`Adding item`);
                    this.dataService.add(scope.baseEndpoint, scope.item, scope.parentItemId, scope.sectionEndpoint).
                        then((data: any): any => {

                            scope.item = {};
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;

                            scope.applyFilter();

                            scope.items.initSearch(buildRequest());
                        });
                } else if (scope.viewMode === Meevo.Model.MaintenanceFormState.Editing) {
                    this.loggingService.trace(`Updating item ${scope.item.id}`);
                    this.dataService.update(scope.baseEndpoint, scope.item, scope.parentItemId, scope.sectionEndpoint)
                        .then((data: any) => {
                            // Hook to provide notification before merging item into list
                            if (scope.postSavePreMerge) {
                                scope.postSavePreMerge({ data: data });
                            }
                            angular.merge(scope.item, data);

                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;

                            this.loggingService.trace(`${scope.item.id} Successfully Updated`);

                            scope.items.initSearch(buildRequest());
                        });
                }

                scope.cancel();
            }

            scope.cancel = (): void => {
                scope.item = {};
                scope.applyFilter();
                scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                scope.context.cancel();
            }

            scope.closeModal = (): void => {
                if (!scope.criteria.includeActive && !scope.criteria.includeInactive && !scope.criteria.includeDeleted) {
                    // Ensures criteria is truthy
                    scope.criteria.includeActive = true;
                }

                this.$mdDialog.cancel();
            }

            scope.clearAdvancedSearch = (): void => {
                scope.initializeCriteria();
                scope.applyFilter();
            }

            scope.initializeCriteria = (): void => {
                if (_.isFunction(scope.defaultCriteria)) {
                    scope.criteria = scope.defaultCriteria();
                }
                if (scope.isApplicationModeCO()) {
                    scope.criteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                }
            }

            /**
            * Determines whether the application is in CO mode
            */
            scope.isApplicationModeCO = (): boolean => {
                return this.identityService.inCentralOfficeMode();
            }

            scope.applyFilterWithValidation = (isValid: boolean): void => {
                if (!isValid) {
                    return;
                }
                scope.applyFilter();
            }
			/**
			* Applies any filter from the UI and initiates a request.
			*/
            scope.applyFilter = (page?: any): void => {
                //temporarily hide pager bar while filtering for results
                scope.hidePagerBar = true;
                if (_.isFunction(scope.onApplyFilter)) {
                    if (!scope.onApplyFilter()) {
                        return;
                    }
                }

                if (scope.criteria.includeActive != undefined &&
                    scope.criteria.includeInactive != undefined &&
                    scope.criteria.includeDeleted != undefined &&
                    !scope.criteria.includeActive &&
                    !scope.criteria.includeInactive &&
                    !scope.criteria.includeDeleted) {
                    scope.clearAdvancedSearch();
                }

                scope.allExpanded = false;
                scope.request = buildRequest();
                if (!scope.request.itemsPerPage) {
                    scope.request.itemsPerPage = 24;
                }
                this.busyService.start();

                this.dataService.getCount(scope.fullEndpoint, scope.request).then((result) => {

                    scope.items.count = result;

                }).then(() => {
                    scope.items.pages = [];
                    this.dataService.getListPaged(scope.fullEndpoint, scope.request).then((result) => {
                        scope.selectableLister();

                        scope.items.currentPage = scope.request.pageNumber;
                        scope.items.pages[0] = result;
						if (_.isFunction(scope.onPageLoaded)) {
							scope.onPageLoaded({ isNewPage: true });
						}
                        scope.selectPage(page);
                        this.busyService.stop();
                        scope.hidePagerBar = false;


					});
                    scope.closeModal();

				});
            }

            /**
            * Opens modal for adding or editing an item.
            */
            scope.openModal = (item: any) => {
				const dialog = this.$mdDialog;

                scope.item = angular.copy(item);

                const options = {
                    scope: scope,
                    templateUrl: scope.addTemplateUrl,
                    controller: 'meevo.components.controls.SublistModalController',
                    controllerAs: 'vm',
                    preserveScope: true
                };

                dialog.show(options);
            }

            /* END: Common Functionality */

            /* START CRUD State Management */

            scope.canAdd = (): boolean => scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            scope.canEdit = (): boolean => scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            scope.canDelete = (): boolean => scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            scope.isAdding = (): boolean => scope.viewMode === Meevo.Model.MaintenanceFormState.Adding;
            scope.isEditing = (): boolean => scope.context.isEditing;

            /* END: CRUD State Management */

            /**
             * Builds a request to retrieve the list of items in a virtualized manner.
             */
            function buildRequest<T, TSearch extends Model.SearchCriteria>(): Model.SearchPage<T, TSearch> {

                const request = <Model.SearchPage<T, TSearch>>{
                    pageNumber: 0,
                    itemsPerPage: scope.itemsPerPage,
                    criteria: scope.criteria,
                    asLocationId: Model.Guard.returnSomething(scope.asLocationId),
                    sortBy: scope.sortBy ? scope.sortBy : null,
                    ...(scope.extendRequest ? scope.requestData : {})
                }
                return request;
            }

            scope.submitForm = () => {
                var invalidItems = [];
                let itemsForRequest = scope.items.pages[scope.items.currentPage];
                angular.forEach(formCtrl.pagerForm, (value, key) => {
                    if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue') && value.$invalid) {
                        invalidItems.push(value);
                    }
                });

                if (invalidItems.length !== 0) {
                    return;
                }

                const requestCallback = (data?: any, page?: any) => {
                    // Hook to provide notification before merging item into list
                    if (scope.postSavePreMerge && data) {
                        scope.postSavePreMerge({ data: data });
                    }
                    // Able to manipulate current context via scope
                    scope.context.mode = Meevo.Model.MaintenanceFormState.Readonly;
                    scope.applyFilter(page);
                    this.busyService.stop();
                };


                if (_.isFunction(scope.customSubmitForm)) {
                    scope.customSubmitForm({applyFilter: scope.applyFilter, criteria: scope.criteria, collapseAll: scope.collapseAll});
                    return;
                }

                this.busyService.start();
                var items = [];
                for (let x in scope.items.pages) {
                    items.concat(x);
                }

                const backup = scope.context.selectedSection.originalEntity;
                if (
                    !scope.isSaveEqual
                    && backup.items.pages[scope.items.currentPage].length > 0
                    && typeof backup.items.pages[scope.items.currentPage][0].overridableFields === 'string'
                    && backup.items.pages[scope.items.currentPage][0].overridableFields.length > 0
                ) {
                    itemsForRequest = getChangedModels(backup.items.pages[scope.items.currentPage], itemsForRequest);
                }

                if (itemsForRequest.length === 0) {
                    return requestCallback();
                }

                var request = {
                    employeeGlobalId: scope.parentId,
                    items: itemsForRequest,
                    asLocationId: Model.Guard.returnSomething(scope.asLocationId),
                    ...(scope.requestData || {})
                };

                if (scope.isAudited) {
                    const nounValue = scope.context.selectedSection.noun;
                    const itemId = scope.context.itemId;
                    if (nounValue) {
						scope.trackUsage(nounValue, Model.VerbEnum.SaveButtonClicked, request.items, itemId);
                    }
                }
                this.dataService.patch(scope.baseEndpoint, request, scope.parentItemId, scope.sectionEndpoint + "/Patch").then(() => {
					requestCallback(scope.items.currentPage);
                });

            }

            function getChangedModels(originalArr: IPagerItem[], changedArr: IPagerItem[]): IPagerItem[] {

                function pickOverridableFields(model: IPagerItem) {
                    return angular.toJson(
                        _.pick.apply(null, [model].concat(
                            model
                                .overridableFields
                                .split(',')
                                .map(fieldName => {
                                    return fieldName.slice(0, 1).toLowerCase() + fieldName.slice(1) // transform to CamelCase
                                })
                        ))
                    ).replace(/"/g, '');
                }

                return <IPagerItem[]>changedArr.filter((model: IPagerItem, index: number) => {

                    // searching for the model in original array
                    // model is changed if we can't find it in the original array
                    return pickOverridableFields(originalArr[index]) !== pickOverridableFields(model);
                });
            };

            function getFullEndpoint() {
                var url = scope.baseEndpoint;
                if (scope.parentItemId && scope.parentItemId.length > 0) {
                    url += `/${scope.parentItemId}`;
                }
                if (scope.sectionEndpoint && scope.sectionEndpoint.length > 0) {
                    url += "/" + scope.sectionEndpoint;
                }

                return url;
            }

            scope.trackUsage = (noun, verb, payload, itemId): void => {
                var trackInfo = new Meevo.Model.TrackingItem(noun, verb, payload, itemId);
                this.trackingService.saveTrackingInfo(trackInfo);
            }

            /* START: Pagination Data Retrieval */

            scope.fullEndpoint = getFullEndpoint();
            scope.items = {};
            scope.itemsArray = scope.items;
            scope.items.currentPage = 0;
            scope.itemsPerPage = isNaN(parseInt(scope.pageSize)) ? 24 : parseInt(scope.pageSize);
            scope.request = buildRequest();

            if(!scope.disableInitialRequest){
            this.busyService.start();
            this.dataService.getCount(scope.fullEndpoint, scope.request).then((result) => {
                scope.items.count = result;
                scope.selectableLister();
            }).then(() => {
                scope.items.pages = [];
                this.dataService.getListPaged(scope.fullEndpoint, scope.request).then((result) => {
                    scope.items.pages[0] = result;
                    if (_.isFunction(scope.onPageLoaded)) {
                        scope.onPageLoaded({ isNewPage: true });
                    }
                    this.busyService.stop();
                });
            });
            }

            scope.selectableLister = (): any => {
                var maxPages = Math.ceil(scope.items.count / scope.itemsPerPage);
                if (maxPages >= 8) {
                    switch (scope.items.currentPage) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            scope.selectablePages = [0, 1, 2, 3, 4, "...", maxPages - 1];
                            break;
                        case maxPages - 3:
                        case maxPages - 2:
                        case maxPages - 1:
                        case maxPages:
                            scope.selectablePages = [0, "...", maxPages - 3, maxPages - 2, maxPages - 1];
                            break;
                        default:
                            scope.selectablePages = [0, "...", scope.items.currentPage - 2, scope.items.currentPage - 1, scope.items.currentPage, scope.items.currentPage + 1, scope.items.currentPage + 2, "...", maxPages - 1];
                            break;
                    }
                } else {
					const pages: number[] = [];
                    for (let i = 0; i < maxPages; i++) {
                        pages.push(i);
                    }
                    scope.selectablePages = pages;
                }

            }

            scope.goToPage = (page: any): void => {
                if (page !== "...") {
                    const newPage = typeof page == "number" ? page : parseInt(page);
                    if (newPage >= 0 && newPage < scope.items.count / scope.itemsPerPage) {
                        scope.items.currentPage = newPage;
                        scope.selectableLister();
                    }
                    scope.request.pageNumber = scope.items.currentPage;
                    if (!scope.items.pages[scope.items.currentPage] || scope.items.pages[scope.items.currentPage].length == 0) {
                        this.busyService.start();
                        this.dataService.getListPaged(scope.fullEndpoint, scope.request).then((result) => {
                            this.busyService.stop();
                            scope.items.pages[scope.items.currentPage] = result;
                            if (_.isFunction(scope.onPageLoaded)) {
                                scope.onPageLoaded({ isNewPage: true });
                            }
                        });
                    } else {
                        if (_.isFunction(scope.onPageLoaded)) {
                            scope.onPageLoaded();
                        }
                    }
                }
            }

            scope.selectPage = (page: any): void => {
                scope.allExpanded = false;

                if (_.isFunction(scope.asyncPreSelectPage)) {
                    scope.asyncPreSelectPage().then((resp: boolean) => {
                        if (resp) {
                            scope.goToPage(page);
                        }
                    });
                } else {
                    if (scope.isEditing())
                        return;

                    scope.goToPage(page);
                }
            }

            scope.expandAll = () => {
                scope.allExpanded = !scope.allExpanded;
                scope.$broadcast('expand-all', { "expanded": scope.allExpanded });
            }

            scope.collapseAll = () => {
                scope.allExpanded = false;
                scope.$broadcast('expand-all', { "expanded": scope.allExpanded });
            }

            scope.selectAll = () => {
                if (_.isFunction(scope.isSelected)) {
                    scope.isSelected();
                }
            }

            scope.toggleCoMenu = (): void => {
                if (scope.coSearchTemplate && scope.templateController) {
					const options: Meevo.Components.Modal.IModalOptions = {
                        preserveScope: true,
                        scope: scope,
                        templateUrl: scope.coSearchTemplate,
                        controller: scope.templateController,
                        controllerAs: "vm",
                        escapeToClose: false,
                        clickOutsideToClose: false,
                        locals: {

                        }
                    }
                    this.modalService.showCustom(options);
                }
            }
            scope.toggleFilter = (key, $event): void => {
                scope.criteria[key] = !scope.criteria[key];
                if (!scope.criteria.includeActive && !scope.criteria.includeInactive && !scope.criteria.includeDeleted) {
                    // Ensures criteria is truthy
                    scope.criteria.includeActive = true;
                }

                $event.stopPropagation();

                scope.applyFilter();
            }
            scope.toggleSearchFilter = ($event): void => {
                scope.intelligentSearch.filter = '';
                $event.stopPropagation();
                scope.applyFilter();
            }

            scope.$watch('itemsArray', () => {
                // when the selectedSection.cancel() happens the selectedSection.model.items lost his link to the
                // scope.itemsArray because of backup and we need to renew it
                scope.itemsArray = scope.items;
            });

            // Virtual method on context in order to interact with pager functionality
            // TODO: Should refactor directive with service-directive design
            scope.context.forcePageLoading = (criteria: any, itemsPerPage?: number): void => {
                $.extend(scope.criteria, criteria);

                if (itemsPerPage) {
                    scope.itemsPerPage = itemsPerPage;
                }

                scope.applyFilter();
            }
        }

        constructor(
			private dataService: Meevo.Components.BaseClasses.IDataService,
			private modalService: Meevo.Components.Modal.IModalService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
			private $mdDialog: ng.material.IDialogService,
			private securityService: Meevo.Components.Common.ISecurityService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private trackingService: Meevo.Components.Tracking.ITrackingService) {
        }

        static factory(): angular.IDirectiveFactory {
			const directive = (dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                $mdDialog: ng.material.IDialogService,
                securityService: Meevo.Components.Common.ISecurityService,
                busyService: Meevo.Components.Busy.IBusyService,
                identityService: Meevo.Components.Common.IIdentityService,
                trackingService: Meevo.Components.Tracking.ITrackingService) => {
                return new MeevoPager(
					dataService,
					modalService,
					loggingService,
					$mdDialog,
					securityService,
					busyService,
					identityService,
					trackingService
				);
            }

            directive.$inject = [
				"meevo.components.common.DataService",
				"meevo.components.modal.ModalService",
				"meevo.components.logging.LoggingService",
				"$mdDialog",
				"meevo.components.common.SecurityService",
				"meevo.components.busy.BusyService",
				"meevo.components.common.IdentityService",
				"meevo.components.tracking.TrackingService"
			];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPager", MeevoPager.factory());
}
